module.exports = __webpack_public_path__ + "static/media/gr-logo.c3361efe.png";